import { baseApi } from '@/lib/api/baseApi';
import { sitesEndpoints } from './sites.queries';

export const sitesApi = baseApi.injectEndpoints({ endpoints: sitesEndpoints });

export const {
  useGetSitesQuery,
  useGetSiteDetailQuery,
  useGetSiteMaterialsQuery,
  useGetAccountTerminalsQuery,
  useGetAccountMbPeriodsQuery,
  useGetSiteMbPeriodQuery,
  useCreateMbPeriodMutation,
  useUpdateMbPeriodMutation,
  useAssignSiteMaterialsMutation,
  useRemoveSiteMaterialMutation,
  useGetSiteFormQuery,
  useCreateSiteMutation,
  useUpdateSiteMutation,
  useCreateTerminalMutation,
  useUpdateTerminalMutation,
  useDeleteTerminalMutation,
} = sitesApi;
